import React from 'react';
import { Modal } from 'src/components/design-system';
import styles from './lab-category-delete.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { Alert } from 'antd';
import { isCompendiumOwner } from 'shared/store/selectors/lab.selector';
import analyticsService from 'src/helpers/analytics.service';
import { EVENTS, ANALYTICS_CONTENT_CATEGORIES_TYPES } from 'shared/constants';
import { getCategoryType } from 'shared/utils';

const LabCategoryDelete = React.memo(function LabCategoryDelete({
  entity = null,
  isOpen = false,
  deleteCategory = () => {},
  onFinish = () => {},
}) {
  const [isLoading, setLoadingState] = React.useState(false);
  const canRemoveCategory = useSelector(state => isCompendiumOwner(state, { id: entity?.id }));
  const lang = useSelector(getLang('DELETE_LAB_CATEGORY_CONFIRMATION'));

  const deleteCategoryAction = async () => {
    setLoadingState(true);
    await deleteCategory({ id: entity?.id });

    if (entity) {
      analyticsService.track(EVENTS.CATEGORIES.REMOVE, {
        categoryType: getCategoryType({ type: entity.type, path: entity.path }),
        contentType: ANALYTICS_CONTENT_CATEGORIES_TYPES.LAB,
        categoryId: entity.id,
        title: entity.title,
        ownerIds: entity.ownerIds,
      });
    }
    setLoadingState(false);
    onFinish();
  };

  return (
    <Modal
      title={lang.TITLE}
      open={isOpen}
      onCancel={onFinish}
      onSubmit={deleteCategoryAction}
      cancelText={lang.DISMISS}
      submitText={lang.CONFIRM}
      loading={isLoading}
      submitDisabled={!canRemoveCategory}
      submitDanger
      restoreFocusAfterDelete
    >
      <p className={styles.content}>{lang.TEXT.replace('{name}', entity?.title)}</p>

      {!canRemoveCategory && (
        <Alert className={styles.alert} message={lang.OWNERSHIP_ERROR} type="error" />
      )}
    </Modal>
  );
});

export { LabCategoryDelete };
